import React from 'react';
import { FiUser, FiFileText } from 'react-icons/fi';
import { useGuest } from '../../context/GuestContext';

const CERTIFICATIONS = [
  'SOC 2 Type II', 'ISO 27001', 'GDPR Compliant',
  'HIPAA Ready', '99.9% Uptime SLA', 'End-to-end Encrypted',
];

const GuestHero = () => {
  const { openRequestModal } = useGuest();

  return (
    <section className="bg-[ #ffffff] text-white py-[3rem]">
      <div className="max-w-screen-2xl mx-auto px-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">

          {/* Left Content */}
          <div>
            <div className="inline-flex items-center gap-2 bg-[#ff6600]/10 border border-[#ff6600]/30 text-[#ff6600] px-4 py-1.5 rounded-full text-sm font-semibold mb-8">
              <span className="w-2 h-2 rounded-full bg-[#ff6600]"></span>
              VERIFIED TRUST CENTER
            </div>
            <h1 className="text-5xl font-bold leading-tight mb-6 text-[#171a1f]">
              Your customers<br />deserve to trust you<br />
              <span className="italic text-[#ff6600]">— effortlessly.</span>
            </h1>
            <p className="text-[#919191] text-lg mb-10 leading-relaxed">
              My Risk Shield is a managed trust center platform. We handle
              the compliance communication layer between you and your
              customers — so trust is always visible, accessible, and
              verifiable.
            </p>
            <div className="flex flex-wrap gap-4 mb-12">
              <button
                onClick={openRequestModal}
                className="bg-[#ff6600] text-white px-8 py-3 hover:bg-[#0077b5]/80 font-semibold transition-colors"
              >
                Send a request
              </button>
              <button
                onClick={() => window.open('https://outlook.office365.com/owa/calendar/ITPeopleNetworkRiskAssessmentSupport@itpeoplenetwork.com/bookings/', '_blank')}
                className="border border-[#919191]/50 text-[#5e6060] px-8 py-3  hover:bg-white/5 transition-colors"
              >
                Schedule a demo
              </button>
            </div>
            <div className="flex flex-wrap gap-x-6 gap-y-2 text-sm text-[#919191]">
              {CERTIFICATIONS.map((cert) => (
                <span key={cert} className="flex items-center gap-1.5">
                  <span className="w-2 h-2 rounded-full bg-[#ff6600] flex-shrink-0"></span>
                  {cert}
                </span>
              ))}
            </div>
          </div>

          {/* Right - Trust Flow Model Image */}
          <div className="flex justify-center lg:justify-end">
            <img
              src="/trust-center/TrustCenterFlow.png"
              alt="Trust Center Flow Model"
              className="w-full max-w-xxl"
            />
          </div>

        </div>
      </div>
    </section>
  );
};

export default GuestHero;
